import {
    FormHelperText,
    Grid,
    InputLabel,
    FormControlLabel,
    Checkbox,
    CircularProgress,
    Radio,
    RadioGroup,
    withStyles,
    TableCell,
    TableBody,
    TableContainer,
    TableRow,
    Table,
    TableHead,
    Tooltip,
    Typography,
    InputAdornment
} from '@material-ui/core';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { CustomColorPicker, Multiselect, SecondaryButton, SelectBox, SingelSelect, TextBox } from '../../../../../Core/FormInput/index.jsx';
import {
    getMADashboardCategoryGetDetailsById,
    postMADashboardCategoryAddUpdate,
    getMADashboardCategoryDropdown,
    postMADashboardMappingCategory_SwapSequence
} from '../../../../../Core/Service/ManageAccount/maDashboard-Category-service';
import AppContext from '../../../../../App/AppContext.js';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import _uniqueId from 'lodash/uniqueId';
import { ArrowDownwardRounded, ArrowUpwardRounded } from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { CustomIconButton } from '../../../../../Core/FormInput/AppButton.jsx';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { stubFalse } from 'lodash';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 16,
        padding: '2px 8px',
        color: '#f50057'
    },
    body: {
        fontSize: 14,
        padding: '2px 8px'
    }
}))(TableCell);
const StyledTableRow = withStyles((theme) => ({
    root: {
        height: '40px',
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const DashboardAddUpdateModal = ({ selectedRowData, onClose, isAdd, dashboardData }) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [isReload, setIsReload] = useState('');
    const [editRowSelectedIndex, setEditRowSelectedIndex] = useState(null);
    const [state, setState] = useState({
        smallSequence: null,
        bigSequence: null,
        mADashboardCategoryId: null,
        mADashboardCategoryName: '',
        mADashboardActualName: '£',
        mADashboardBudgetName: '£',
        mADashboardVarianceName: '£',
        mADashboardKPIsName: 'Mix',
        mADashboardID: dashboardData?.maDashboardID,
        mADashboardHasAverage: false,
        mADashboardHasTotal: false,
        mADashboardSequence: '',
        mADashboardDecimalPlaces: '',
        mAMappingCategoryName: '',
        categoryID: [],
        //maMappingCategoryID: [],
        maMappingCategoryList: [],
        otherCategories: [],
        stdDataCategory: null,
        stdDataCategoryOtherCategories: null,
        tempMAMappingCategoryList: [],
        mADashboardActualTextColor: '',
        mADashboardBudgetTextColor: '',
        mADashboardVarianceTextColor: '',
        mADashboardKPIsTextColor: '',
        mADashboardActualBgColor: '',
        mADashboardBudgetBgColor: '',
        mADashboardVarianceBgColor: '',
        mADashboardKPIsBgColor: '',
        mADashboardActualHasTotal: false,
        mADashboardBudgetHasTotal: false,
        mADashboardVarianceHasTotal: false,
        mADashboardKPIsHasTotal: false,
        mADashboardActualHasAverage: false,
        mADashboardBudgetHasAverage: false,
        mADashboardVarianceHasAverage: false,
        mADashboardKPIsHasAverage: false,
        mADashboardFooterTitle: '',
        mADashboardFooterTextColor: '',
        mADashboardFooterBgColor: '',
        mADashboardShowTotalFooter: false,
        mADashboardActualPYName: '£',
        mADashboardActualPYTextColor: '',
        mADashboardActualPYBgColor: '',
        mADashboardActualPYHasTotal: false,
        mADashboardActualPYHasAverage: false,
        mADashboardVarLYName: '£',
        mADashboardVarLYTextColor: '',
        mADashboardVarLYBgColor: '',
        mADashboardVarLYHasTotal: false,
        mADashboardVarLYHasAverage: false,
        mADashboardHeaderBgColor: '',
        mADashboardHeaderTextColor: '',
        mADashboardUseHeaderColor: false,
        displayDataLive: true,
        maDashboardMappingCategoryID: null,
        maDashboardCategoryId: null,
        maMappingCategoryTitle: '',
        maMappingCategoryCalculated: false,
        maMappingCategoryID: [],
        maMappingCategoryCalculation: '',
        IsDeleted: false,
        selectedSymbol: null,
        maMappingCategorySequence: '',
        isUpdate: false,
        isDeleted: false,
        mADashboardCategoryIsExpand: true,
        mADashboardCategoryDataCalculated: 0,

        symbols: [
            { id: 1, name: '+' },
            { id: 2, name: '-' },
            { id: 3, name: '*' },
            { id: 4, name: '/' },
            { id: 5, name: '(' },
            { id: 6, name: ')' }
        ],
        errors: {}
    });

    const [otherCategories, setOtherCategories] = useState({
        maMappingCategoryCalculationOtherCategories: '',
        maMappingCategoryCalculationOtherCategoriesIDValue: '',
        selectedDataCategoryOtherCategories: null,
        selectedSymbolOtherCategories: null,
        maDashboardMappingCategoryID: '',
        maMappingCategorySequence: '',
        maMappingCategoryTitle: ''
    });

    useEffect(() => {
        if (!isAdd && selectedRowData) {
            const fetchDetails = async () => {
                try {
                    setLoading(true);
                    const res = await getMADashboardCategoryGetDetailsById(selectedRowData.maDashboardCategoryId);
                    if (res.success) {
                        const data = res.data?.list?.[0];
                        let newst = {};
                        if (res.data.maMappingCategoryID.length > 0) {
                            newst.smallSequence = res.data?.maMappingCategoryID?.reduce((acc, loc) =>
                                acc.maMappingCategorySequence < loc.maMappingCategorySequence ? acc : loc
                            ).maMappingCategorySequence;
                            newst.bigSequence = res.data?.maMappingCategoryID?.reduce((acc, loc) =>
                                acc.maMappingCategorySequence > loc.maMappingCategorySequence ? acc : loc
                            ).maMappingCategorySequence;
                        }

                        if (data.maDashboardCategoryDataCalculated) {
                            setState((prev) => ({
                                ...prev,
                                mADashboardCategoryId: data.maDashboardCategoryId,
                                mADashboardCategoryName: data.maDashboardCategoryName,
                                mADashboardActualName: data.maDashboardActualName,
                                mADashboardBudgetName: data.maDashboardBudgetName,
                                mADashboardVarianceName: data.maDashboardVarianceName,
                                mADashboardKPIsName: data.maDashboardKPIsName,
                                mADashboardHasAverage: data.maDashboardHasAverage,
                                mADashboardHasTotal: data.maDashboardHasTotal,
                                mADashboardSequence: data.maDashboardSequence || 1,
                                mADashboardDecimalPlaces: data.maDashboardDecimalPlaces,
                                // maMappingCategoryID: res.data?.maMappingCategoryID,
                                mADashboardActualTextColor: data.maDashboardActualTextColor,
                                mADashboardBudgetTextColor: data.maDashboardBudgetTextColor,
                                mADashboardVarianceTextColor: data.maDashboardVarianceTextColor,
                                mADashboardKPIsTextColor: data.maDashboardKPIsTextColor,
                                mADashboardActualBgColor: data.maDashboardActualBgColor,
                                mADashboardBudgetBgColor: data.maDashboardBudgetBgColor,
                                mADashboardVarianceBgColor: data.maDashboardVarianceBgColor,
                                mADashboardKPIsBgColor: data.maDashboardKPIsBgColor,
                                mADashboardActualHasTotal: data.maDashboardActualHasTotal,
                                mADashboardBudgetHasTotal: data.maDashboardBudgetHasTotal,
                                mADashboardVarianceHasTotal: data.maDashboardVarianceHasTotal,
                                mADashboardKPIsHasTotal: data.maDashboardKPIsHasTotal,
                                mADashboardActualHasAverage: data.maDashboardActualHasAverage,
                                mADashboardBudgetHasAverage: data.maDashboardBudgetHasAverage,
                                mADashboardVarianceHasAverage: data.maDashboardVarianceHasAverage,
                                mADashboardKPIsHasAverage: data.maDashboardKPIsHasAverage,
                                mADashboardFooterTitle: data.maDashboardFooterTitle,
                                mADashboardFooterTextColor: data.maDashboardFooterTextColor,
                                mADashboardFooterBgColor: data.maDashboardFooterBgColor,
                                mADashboardShowTotalFooter: data.maDashboardShowTotalFooter,
                                mADashboardActualPYName: data.maDashboardActualPYName,
                                mADashboardActualPYTextColor: data.maDashboardActualPYTextColor,
                                mADashboardActualPYBgColor: data.maDashboardActualPYBgColor,
                                mADashboardActualPYHasTotal: data.maDashboardActualPYHasTotal,
                                mADashboardActualPYHasAverage: data.maDashboardActualPYHasAverage,
                                mADashboardVarLYName: data.maDashboardVarLYName,
                                mADashboardVarLYTextColor: data.maDashboardVarLYTextColor,
                                mADashboardVarLYBgColor: data.maDashboardVarLYBgColor,
                                mADashboardVarLYHasTotal: data.maDashboardVarLYHasTotal,
                                mADashboardVarLYHasAverage: data.maDashboardVarLYHasAverage,
                                mADashboardHeaderBgColor: data.maDashboardHeaderBgColor,
                                mADashboardHeaderTextColor: data.maDashboardHeaderTextColor,
                                mADashboardUseHeaderColor: data.maDashboardUseHeaderColor,
                                displayDataLive: data.displayDataLive,
                                mADashboardCategoryDataCalculated: data.maDashboardCategoryDataCalculated,
                                mADashboardCategoryIsExpand: data.maDashboardCategoryIsExpand,
                                maMappingCategoryID: [],

                                ...newst
                            }));

                            setOtherCategories((st) => ({
                                ...st,
                                // maMappingCategoryCalculationOtherCategories: res.data.maMappingCategoryID[0].maMappingCategoryCalculation || '',
                                maMappingCategoryCalculationOtherCategoriesIDValue: res.data.maMappingCategoryID[0].maMappingCategoryCalculation || '',
                                maDashboardMappingCategoryID: res.data.maMappingCategoryID[0].maDashboardMappingCategoryID,
                                maMappingCategorySequence: res.data.maMappingCategoryID[0].maMappingCategorySequence,
                                maMappingCategoryTitle: res.data.maMappingCategoryID[0].maMappingCategoryTitle
                            }));
                        } else {
                            setState((prev) => ({
                                ...prev,
                                mADashboardCategoryId: data.maDashboardCategoryId,
                                mADashboardCategoryName: data.maDashboardCategoryName,
                                mADashboardActualName: data.maDashboardActualName,
                                mADashboardBudgetName: data.maDashboardBudgetName,
                                mADashboardVarianceName: data.maDashboardVarianceName,
                                mADashboardKPIsName: data.maDashboardKPIsName,
                                mADashboardHasAverage: data.maDashboardHasAverage,
                                mADashboardHasTotal: data.maDashboardHasTotal,
                                mADashboardSequence: data.maDashboardSequence || 1,
                                mADashboardDecimalPlaces: data?.maDashboardDecimalPlaces,
                                // maMappingCategoryID: res.data?.maMappingCategoryID,
                                mADashboardActualTextColor: data.maDashboardActualTextColor,
                                mADashboardBudgetTextColor: data.maDashboardBudgetTextColor,
                                mADashboardVarianceTextColor: data.maDashboardVarianceTextColor,
                                mADashboardKPIsTextColor: data.maDashboardKPIsTextColor,
                                mADashboardActualBgColor: data.maDashboardActualBgColor,
                                mADashboardBudgetBgColor: data.maDashboardBudgetBgColor,
                                mADashboardVarianceBgColor: data.maDashboardVarianceBgColor,
                                mADashboardKPIsBgColor: data.maDashboardKPIsBgColor,
                                mADashboardActualHasTotal: data.maDashboardActualHasTotal,
                                mADashboardBudgetHasTotal: data.maDashboardBudgetHasTotal,
                                mADashboardVarianceHasTotal: data.maDashboardVarianceHasTotal,
                                mADashboardKPIsHasTotal: data.maDashboardKPIsHasTotal,
                                mADashboardActualHasAverage: data.maDashboardActualHasAverage,
                                mADashboardBudgetHasAverage: data.maDashboardBudgetHasAverage,
                                mADashboardVarianceHasAverage: data.maDashboardVarianceHasAverage,
                                mADashboardKPIsHasAverage: data.maDashboardKPIsHasAverage,
                                mADashboardFooterTitle: data.maDashboardFooterTitle,
                                mADashboardFooterTextColor: data.maDashboardFooterTextColor,
                                mADashboardFooterBgColor: data.maDashboardFooterBgColor,
                                mADashboardShowTotalFooter: data.maDashboardShowTotalFooter,
                                mADashboardActualPYName: data.maDashboardActualPYName,
                                mADashboardActualPYTextColor: data.maDashboardActualPYTextColor,
                                mADashboardActualPYBgColor: data.maDashboardActualPYBgColor,
                                mADashboardActualPYHasTotal: data.maDashboardActualPYHasTotal,
                                mADashboardActualPYHasAverage: data.maDashboardActualPYHasAverage,
                                mADashboardVarLYName: data.maDashboardVarLYName,
                                mADashboardVarLYTextColor: data.maDashboardVarLYTextColor,
                                mADashboardVarLYBgColor: data.maDashboardVarLYBgColor,
                                mADashboardVarLYHasTotal: data.maDashboardVarLYHasTotal,
                                mADashboardVarLYHasAverage: data.maDashboardVarLYHasAverage,
                                mADashboardHeaderBgColor: data.maDashboardHeaderBgColor,
                                mADashboardHeaderTextColor: data.maDashboardHeaderTextColor,
                                mADashboardUseHeaderColor: data.maDashboardUseHeaderColor,
                                displayDataLive: data.displayDataLive,
                                mADashboardCategoryDataCalculated: data.maDashboardCategoryDataCalculated,
                                mADashboardCategoryIsExpand: data.maDashboardCategoryIsExpand,
                                maMappingCategoryID:
                                    res.data.maMappingCategoryID.length > 0 ? res.data.maMappingCategoryID.map((q) => ({ ...q, isDeleted: false })) : [],

                                ...newst
                            }));
                        }
                    } else {
                        showToast('Failed to fetch category details.');
                    }
                } catch (error) {
                    showToast('Error fetching category details.');
                } finally {
                    setLoading(false);
                }
            };

            fetchDetails();
        }
    }, [selectedRowData, isAdd, isReload]);

    const handleDeleteRecord = (data) => {
        setState((prevState) => {
            const updatedCategoryID = prevState.maMappingCategoryID
                .map((item) =>
                    item.maMappingCategoryID === data.maMappingCategoryID
                        ? item.maDashboardMappingCategoryID
                            ? { ...item, isDeleted: true } // Mark as deleted if it has `maDashboardMappingCategoryID`
                            : null // Remove permanently if it doesn't
                        : item
                )
                .filter(Boolean); // Remove `null` values (permanently deleted items)

            return {
                ...prevState,
                maMappingCategoryID: [...updatedCategoryID] // Ensures a new reference
            };
        });
    };

    const inputChange = useCallback((e) => {
        const { name, value } = e.target;

        setState((prev) => ({
            ...prev,
            [name]: value,
            errors: { ...prev.errors, [name]: null }
        }));
    }, []);

    const handleSymbolSelect = (name) => (event, value) => {
        if (!value?.name) return;
        if (name === 'selectedSymbolOtherCategories') {
            setOtherCategories((prev) => ({
                ...prev,
                // maMappingCategoryCalculationOtherCategories:
                //     (prev.maMappingCategoryCalculationOtherCategories ? prev.maMappingCategoryCalculationOtherCategories + ' ' : '') + value.name,
                maMappingCategoryCalculationOtherCategoriesIDValue:
                    (prev.maMappingCategoryCalculationOtherCategoriesIDValue ? prev.maMappingCategoryCalculationOtherCategoriesIDValue + '' : '') + value.name,
                [name]: ''
            }));
        } else {
            setState((prev) => ({
                ...prev,
                maMappingCategoryCalculation: (prev.maMappingCategoryCalculation ? prev.maMappingCategoryCalculation + ' ' : '') + value.name,
                [name]: value
            }));
        }
    };
    const handleMappingCatSelect = (name) => (event, value) => {
        // Extract the text inside brackets (if available)
        const bracketValue = value?.name ? value.name.match(/\((.*?)\)/)?.[1] || '' : '';
        const formatCategoryTitle = value?.name.replace(/\s*\((.*?)\)\s*/, ' - $1');

        setState((prev) => ({
            ...prev,
            maMappingCategoryTitle: bracketValue, // Store the bracketed value
            formatCategoryTitle: formatCategoryTitle,
            [name]: value
        }));
    };

    const handleDataCategorySelect = (ev, value) => {
        if (value) {
            setState((prev) => ({
                ...prev,
                maMappingCategoryCalculation: prev.maMappingCategoryCalculation
                    ? prev.maMappingCategoryCalculation + ' ' + value?.code + ' '
                    : value?.code + ' ',
                selectedDataCategory: value
            }));
        }
    };
    const handleOtherDataCategorySelect = (ev, value) => {
        if (value) {
            setOtherCategories((prev) => ({
                ...prev,
                // maMappingCategoryCalculationOtherCategories: prev.maMappingCategoryCalculationOtherCategories
                //     ? prev.maMappingCategoryCalculationOtherCategories + ' ' + value?.name + ' '
                //     : value?.name + ' ',

                maMappingCategoryCalculationOtherCategoriesIDValue: prev.maMappingCategoryCalculationOtherCategoriesIDValue
                    ? prev.maMappingCategoryCalculationOtherCategoriesIDValue + `#${value?.id}#`
                    : `#${value?.id}#`,
                selectedDataCategoryOtherCategories: ''
            }));
        }
    };

    const validation = () => {
        const newErrors = {};
        const requiredFields = ['mADashboardCategoryName', 'mADashboardSequence'];

        requiredFields.forEach((field) => {
            if (typeof state[field] === 'string') {
                if (!state[field]?.trim()) {
                    newErrors[field] = 'This field is required';
                }
            } else {
                if (state[field] === null || state[field] === undefined || state[field] === '') {
                    newErrors[field] = 'This field is required';
                }
            }
        });

        if (isNaN(state.mADashboardSequence) || state.mADashboardSequence < 0) {
            newErrors.mADashboardSequence = 'Invalid sequence number';
        }

        setState((prev) => ({ ...prev, errors: newErrors }));
        return Object.keys(newErrors).length === 0;
    };

    const submitFrom = async () => {
        if (!validation()) {
            showToast('Please fill all required fields correctly');
            return;
        }
        try {
            setLoading(true);
            const data = {
                mADashboardCategoryId: isAdd ? null : state.mADashboardCategoryId,
                mADashboardID: state.mADashboardID,
                mADashboardCategoryName: state.mADashboardCategoryName,
                mADashboardActualName: state.mADashboardActualName,
                mADashboardBudgetName: state.mADashboardBudgetName,
                mADashboardVarianceName: state.mADashboardVarianceName,
                mADashboardKPIsName: state.mADashboardKPIsName,
                mADashboardHasAverage: state.mADashboardHasAverage,
                mADashboardHasTotal: state.mADashboardHasTotal,
                mADashboardDecimalPlaces: state.mADashboardDecimalPlaces,
                mADashboardSequence: parseInt(state.mADashboardSequence || 1),
                // maMappingCategoryID: state.maMappingCategoryID || [],
                mADashboardActualTextColor: state.mADashboardActualTextColor,
                mADashboardBudgetTextColor: state.mADashboardBudgetTextColor,
                mADashboardVarianceTextColor: state.mADashboardVarianceTextColor,
                mADashboardKPIsTextColor: state.mADashboardKPIsTextColor,
                mADashboardActualBgColor: state.mADashboardActualBgColor,
                mADashboardBudgetBgColor: state.mADashboardBudgetBgColor,
                mADashboardVarianceBgColor: state.mADashboardVarianceBgColor,
                mADashboardKPIsBgColor: state.mADashboardKPIsBgColor,
                mADashboardActualHasTotal: state.mADashboardActualHasTotal,
                mADashboardBudgetHasTotal: state.mADashboardBudgetHasTotal,
                mADashboardVarianceHasTotal: state.mADashboardVarianceHasTotal,
                mADashboardKPIsHasTotal: state.mADashboardKPIsHasTotal,
                mADashboardActualHasAverage: state.mADashboardActualHasAverage,
                mADashboardBudgetHasAverage: state.mADashboardBudgetHasAverage,
                mADashboardVarianceHasAverage: state.mADashboardVarianceHasAverage,
                mADashboardKPIsHasAverage: state.mADashboardKPIsHasAverage,
                mADashboardFooterTitle: state.mADashboardFooterTitle,
                mADashboardFooterTextColor: state.mADashboardFooterTextColor,
                mADashboardFooterBgColor: state.mADashboardFooterBgColor,
                mADashboardShowTotalFooter: state.mADashboardShowTotalFooter,
                mADashboardActualPYName: state.mADashboardActualPYName,
                mADashboardActualPYTextColor: state.mADashboardActualPYTextColor,
                mADashboardActualPYBgColor: state.mADashboardActualPYBgColor,
                mADashboardActualPYHasTotal: state.mADashboardActualPYHasTotal,
                mADashboardActualPYHasAverage: state.mADashboardActualPYHasAverage,
                mADashboardVarLYName: state.mADashboardVarLYName,
                mADashboardVarLYTextColor: state.mADashboardVarLYTextColor,
                mADashboardVarLYBgColor: state.mADashboardVarLYBgColor,
                mADashboardVarLYHasTotal: state.mADashboardVarLYHasTotal,
                mADashboardVarLYHasAverage: state.mADashboardVarLYHasAverage,
                mADashboardHeaderBgColor: state.mADashboardHeaderBgColor,
                mADashboardHeaderTextColor: state.mADashboardHeaderTextColor,
                mADashboardUseHeaderColor: state.mADashboardUseHeaderColor,
                displayDataLive: state.displayDataLive,
                mADashboardCategoryDataCalculated: state.mADashboardCategoryDataCalculated,
                mADashboardCategoryIsExpand: state.mADashboardCategoryIsExpand
            };

            if (state.mADashboardCategoryDataCalculated) {
                const calculationRegex = /^\s*(\(*\s*\#\d+\#\s*\)*\s*([\+\-\*\/]\s*\(*\s*\#\d+\#\s*\)*)*)\s*$/;
                if (!otherCategories.maMappingCategoryCalculationOtherCategoriesIDValue) {
                    showToast('Please select Category calculation');
                    return;
                }
                if (
                    otherCategories.maMappingCategoryCalculationOtherCategoriesIDValue &&
                    !calculationRegex.test(otherCategories.maMappingCategoryCalculationOtherCategoriesIDValue)
                ) {
                    showToast('Invalid calculation format');
                    return;
                }
                data.maMappingCategoryID = [
                    {
                        maDashboardCategoryId: state.mADashboardCategoryId,
                        maMappingCategoryTitle: '#CalculatedCategory#',
                        maMappingCategoryCalculated: true,
                        maMappingCategoryID: null,
                        maDashboardMappingCategoryID: otherCategories.maDashboardMappingCategoryID || null,
                        maMappingCategoryCalculation: otherCategories.maMappingCategoryCalculationOtherCategoriesIDValue,
                        isDeleted: false,
                        maMappingCategorySequence: _uniqueId()
                    }
                ];
            } else {
                data.maMappingCategoryID = state.maMappingCategoryID || [];
            }
            const res = await postMADashboardCategoryAddUpdate(data);
            if (res.success) {
                showToast(`Category ${isAdd ? 'added' : 'updated'} successfully`);
                onClose(true);
            } else {
                showToast(res.message || 'Operation failed');
            }
        } catch (error) {
            showToast(`Error: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleCheckbox = (e) => {
        const { name, checked } = e.target;
        if (name === 'displayDataLive') {
            setState((prev) => ({ ...prev, displayDataLive: true }));
        } else if (name === 'displayDataHistoric') {
            setState((prev) => ({ ...prev, displayDataLive: false }));
        } else if (name === 'mADashboardUseHeaderColor') {
            setState((prev) => ({ ...prev, mADashboardUseHeaderColor: checked }));
        } else {
            const isTotal = name.includes('HasTotal');
            const prefix = name.replace(isTotal ? 'HasTotal' : 'HasAverage', '');

            setState((prev) => ({
                ...prev,
                [name]: checked,
                [`${prefix}${isTotal ? 'HasAverage' : 'HasTotal'}`]: checked ? false : prev[`${prefix}${isTotal ? 'HasAverage' : 'HasTotal'}`]
            }));
        }
    };

    useEffect(() => {
        const fetchMappingCategory = async () => {
            try {
                setLoading(true);
                const res = await getMADashboardCategoryDropdown(state.mADashboardID);
                if (res.success) {
                    setState((prev) => ({
                        ...prev,
                        maMappingCategoryList: res.data?.maMappingCategory,
                        otherCategories: res.data?.otherCategories
                    }));
                } else {
                    showToast('Failed to load mapping categories.');
                }
            } catch (error) {
                showToast('Error fetching mapping categories.');
            } finally {
                setLoading(false);
            }
        };
        fetchMappingCategory();
    }, [state.mADashboardID]);

    // useEffect(() => {
    //     if (state.mADashboardCategoryDataCalculated && state.otherCategories.length > 0 && otherCategories.maMappingCategoryCalculationOtherCategoriesIDValue) {
    //         setOtherCategories((prev) => ({
    //             ...prev,
    //             maMappingCategoryCalculationOtherCategories:
    //                 otherCategories.maMappingCategoryCalculationOtherCategoriesIDValue.replace(/#(\d+)#/g, (_, id) => {
    //                     const item = state.otherCategories.find((obj) => obj.id === parseInt(id));
    //                     return item ? item.name.trim() : '';
    //                 }) || ''
    //         }));
    //     }
    // }, [state.mADashboardCategoryDataCalculated, state.otherCategories, otherCategories.maMappingCategoryCalculationOtherCategoriesIDValue]);

    useEffect(() => {
        if (state.maMappingCategoryList.length > 0 && state.maMappingCategoryID.length > 0) {
            const filteredArray = state.maMappingCategoryList.filter((bItem) => {
                if (!bItem?.id) return true; // Ensure id exists in `bItem`

                return !state.maMappingCategoryID.some((aItem) => aItem.maMappingCategoryID === bItem.id && !aItem.isDeleted);
            });

            setState((prev) => ({
                ...prev,
                tempMAMappingCategoryList: filteredArray
            }));
        } else {
            setState((prev) => ({
                ...prev,
                tempMAMappingCategoryList: state.maMappingCategoryList
            }));
        }
    }, [state.maMappingCategoryList, state.maMappingCategoryID]);

    const syncDependentColors = (name, updatedColor) => {
        const updates = { [name]: updatedColor.hex };

        if (name === 'mADashboardHeaderTextColor') {
            updates.mADashboardFooterTextColor = updatedColor.hex;
            updates.mADashboardActualTextColor = updatedColor.hex;
            updates.mADashboardBudgetTextColor = updatedColor.hex;
            updates.mADashboardVarianceTextColor = updatedColor.hex;
            updates.mADashboardKPIsTextColor = updatedColor.hex;
            updates.mADashboardActualPYTextColor = updatedColor.hex;
            updates.mADashboardVarLYTextColor = updatedColor.hex;
        }

        if (name === 'mADashboardHeaderBgColor') {
            updates.mADashboardFooterBgColor = updatedColor.hex;
            updates.mADashboardActualBgColor = updatedColor.hex;
            updates.mADashboardBudgetBgColor = updatedColor.hex;
            updates.mADashboardVarianceBgColor = updatedColor.hex;
            updates.mADashboardKPIsBgColor = updatedColor.hex;
            updates.mADashboardActualPYBgColor = updatedColor.hex;
            updates.mADashboardVarLYBgColor = updatedColor.hex;
        }

        return updates;
    };

    const OnColorSelect = (updatedColor, name) => {
        setState((prev) => {
            if (prev.mADashboardUseHeaderColor) {
                return { ...prev, ...syncDependentColors(name, updatedColor) };
            }
            return { ...prev, [name]: updatedColor.hex };
        });
    };

    const addCategory = () => {
        const calculationRegex = /^\(*\s*(?:[A-Z]+\d+[A-Z]*|\d+)\s*(?:[\+\-\*\/]\s*\(*\s*(?:[A-Z]+\d+[A-Z]*|\d+)\s*\)*)*\s*\)*$/;

        if (!state.isUpdate) {
            let sameTitleExists = state.maMappingCategoryID.find(
                (w) => w.maMappingCategoryTitle.trim().toUpperCase() === state.maMappingCategoryTitle.trim().toUpperCase() && !w.isDeleted
            );

            if (sameTitleExists) {
                showToast('Title already exists');
                return;
            }
        }

        if (!state.maMappingCategoryTitle) {
            showToast('Title is required');
            return;
        }

        if (!state.maMappingCategoryTitle) {
            showToast('Title is required');
            return;
        }

        if (state.maMappingCategoryCalculation && !calculationRegex.test(state.maMappingCategoryCalculation)) {
            showToast('Invalid calculation format');
            return;
        }

        if (state.isUpdate) {
            let updatedPartToAdd = {
                maDashboardCategoryId: state.mADashboardCategoryId,
                maMappingCategoryTitle: state.maMappingCategoryTitle,
                maMappingCategoryCalculated: state.maMappingCategoryCalculated,
                maMappingCategoryID: state.stdDataCategory?.id || null,
                category: state.formatCategoryTitle || '',
                maMappingCategoryCalculation: state.maMappingCategoryCalculation,
                isDeleted: state.isDeleted || false,
                maMappingCategorySequence: state.maMappingCategorySequence,
                // isLocal: true,
                ...(state.maDashboardMappingCategoryID && { maDashboardMappingCategoryID: state.maDashboardMappingCategoryID || null })
            };
            let updatedCategoryID = state.maMappingCategoryID.map((item) =>
                item.maDashboardMappingCategoryID === state.maDashboardMappingCategoryID ? { ...item, ...updatedPartToAdd } : item
            );

            setEditRowSelectedIndex(null);

            setState((st) => {
                return {
                    ...st,
                    maMappingCategoryID: updatedCategoryID,
                    maMappingCategoryTitle: '',
                    stdDataCategory: {},
                    maMappingCategoryCalculated: false,
                    maMappingCategoryCalculation: '',
                    isUpdate: false,
                    maDashboardMappingCategoryID: undefined
                };
            });
        } else {
            let newPartToAdd = {
                maDashboardCategoryId: state.mADashboardCategoryId,
                maMappingCategoryTitle: state.maMappingCategoryTitle,
                maMappingCategoryCalculated: state.maMappingCategoryCalculated,
                maMappingCategoryID:
                    // state.maMappingCategoryCalculated ? state.selectedDataCategory?.id :
                    state.stdDataCategory?.id || null,
                category: state.formatCategoryTitle || '',
                maMappingCategoryCalculation: state.maMappingCategoryCalculation,
                isDeleted: state.isDeleted || false,
                maMappingCategorySequence: _uniqueId(),
                isLocal: true,
                ...(state.maDashboardMappingCategoryID && { maDashboardMappingCategoryID: state.maDashboardMappingCategoryID || null })
            };

            setState((st) => {
                return {
                    ...st,
                    maMappingCategoryID: [...st.maMappingCategoryID, { ...newPartToAdd }],
                    maMappingCategoryTitle: '',
                    stdDataCategory: {},
                    maMappingCategoryCalculated: '',
                    maMappingCategoryCalculation: '',
                    isUpdate: false,
                    maDashboardMappingCategoryID: undefined
                };
            });
        }
    };

    // useEffect(() => {
    //     function fetchData() {
    //         try {
    //             if (state.maMappingCategoryID.length > 0 && state.maMappingCategoryList.length > 0) {
    //                 const filterVehCat = state.maMappingCategoryList.filter((w) => state.maMappingCategoryID.indexOf(w.id) > -1);
    //                 setState((st) => ({ ...st, categoryID: filterVehCat }));
    //             }
    //         } catch (error) {
    //             console.warn(error);
    //         }
    //     }
    //     return fetchData();
    // }, [state.maMappingCategoryID, state.maMappingCategoryList]);

    const syncHeaderColors = (prevState, useHeaderColors) => {
        if (useHeaderColors) {
            return {
                ...prevState,
                mADashboardUseHeaderColor: true,
                mADashboardFooterTextColor: prevState.mADashboardHeaderTextColor,
                mADashboardActualTextColor: prevState.mADashboardHeaderTextColor,
                mADashboardBudgetTextColor: prevState.mADashboardHeaderTextColor,
                mADashboardVarianceTextColor: prevState.mADashboardHeaderTextColor,
                mADashboardKPIsTextColor: prevState.mADashboardHeaderTextColor,
                mADashboardActualPYTextColor: prevState.mADashboardHeaderTextColor,
                mADashboardVarLYTextColor: prevState.mADashboardHeaderTextColor,
                mADashboardFooterBgColor: prevState.mADashboardHeaderBgColor,
                mADashboardActualBgColor: prevState.mADashboardHeaderBgColor,
                mADashboardBudgetBgColor: prevState.mADashboardHeaderBgColor,
                mADashboardVarianceBgColor: prevState.mADashboardHeaderBgColor,
                mADashboardKPIsBgColor: prevState.mADashboardHeaderBgColor,
                mADashboardActualPYBgColor: prevState.mADashboardHeaderBgColor,
                mADashboardVarLYBgColor: prevState.mADashboardHeaderBgColor
            };
        }
        return {
            ...prevState,
            mADashboardUseHeaderColor: false
        };
    };

    const handleMoveClick = async (record, move) => {
        let switchRecord;
        let index = state.maMappingCategoryID
            ?.map(function (e) {
                return e.maDashboardMappingCategoryID;
            })
            .indexOf(record.maDashboardMappingCategoryID);

        if (move == 'up') {
            switchRecord = state.maMappingCategoryID[index - 1];
        }

        if (move == 'down') {
            switchRecord = state.maMappingCategoryID[index + 1];
        }
        // const formID = PramDynamicFormID;
        const rec1 = record.maDashboardMappingCategoryID;
        const rec2 = switchRecord.maDashboardMappingCategoryID;

        const res = await postMADashboardMappingCategory_SwapSequence(
            // formID,
            rec1,
            rec2
        ).then((res) => {
            if (res.success) {
                setIsReload(new Date());
                showToast(res.data.message || 'Operation failed');
            } else {
                showToast(res.message || 'Operation failed');
            }
        });
    };

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: '920px' }}>
                <CircularProgress />
            </Grid>
        );
    }

    const editRowSelect = (data, index) => {
        if (index != null) {
            let temp = state.maMappingCategoryList.find((w) => w.id === data.maMappingCategoryID);

            setEditRowSelectedIndex(index);
            let data2 = {
                // maDashboardCategoryId: data.maDashboardCategoryId,
                maDashboardCategoryId: data.maDashboardCategoryId,
                maMappingCategoryTitle: data.maMappingCategoryTitle,
                maMappingCategoryCalculated: data.maMappingCategoryCalculated,
                stdDataCategory: temp || null,
                formatCategoryTitle: data.category || '',
                maMappingCategoryCalculation: data.maMappingCategoryCalculation,
                isDeleted: data.isDeleted || false,
                maMappingCategorySequence: data.maMappingCategorySequence,
                isUpdate: true,
                ...(data.maDashboardMappingCategoryID && { maDashboardMappingCategoryID: data.maDashboardMappingCategoryID || null })
            };
            setState((st) => {
                return {
                    ...st,
                    ...data2
                };
            });
        } else {
            setEditRowSelectedIndex(null);
            setState((st) => {
                return {
                    ...st,

                    maMappingCategoryTitle: '',
                    stdDataCategory: {},
                    maMappingCategoryCalculated: false,
                    maMappingCategoryCalculation: '',
                    isUpdate: false,
                    maDashboardMappingCategoryID: undefined
                };
            });
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setState((prevState) => {
            if (name === 'mADashboardCategoryIsExpand') {
                return {
                    ...prevState,
                    [name]: value
                };
            } else if (name === 'mADashboardCategoryDataCalculated') {
                return {
                    ...prevState,
                    [name]: parseInt(value)
                };
            }
            return {
                ...prevState,
                [name]: value
            };
        });
    };

    const resetCalclations = (e) => {
        setOtherCategories((prev) => ({
            ...prev,

            maMappingCategoryCalculationOtherCategoriesIDValue: ''
        }));
    };

    return (
        <Grid container>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <InputLabel shrink required className="mandatoryfields">
                        Category Name
                    </InputLabel>
                    <TextBox
                        placeholder="Category Name"
                        value={state.mADashboardCategoryName}
                        onChange={inputChange}
                        name="mADashboardCategoryName"
                        error={!!state.errors.mADashboardCategoryName}
                        inputProps={{ maxLength: 50 }}
                    />
                    <FormHelperText error>{state.errors.mADashboardCategoryName}</FormHelperText>
                </Grid>
                <Grid item xs={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <InputLabel shrink required className="mandatoryfields">
                                Sequence
                            </InputLabel>
                            <TextBox
                                placeholder="Sequence"
                                type="number"
                                value={state.mADashboardSequence}
                                onChange={inputChange}
                                name="mADashboardSequence"
                                error={!!state.errors.mADashboardSequence}
                                inputProps={{
                                    onInput: (e) => {
                                        if (e.target.value > 32767) e.target.value = 32767;
                                        if (e.target.value < 1) e.target.value = '';
                                    }
                                }}
                            />
                            <FormHelperText error>{state.errors.mADashboardSequence}</FormHelperText>
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel shrink style={{ marginBottom: '7px' }}>
                                Decimal Places
                            </InputLabel>
                            <SelectBox
                                onChange={inputChange}
                                name="mADashboardDecimalPlaces"
                                List={[
                                    { name: '1', id: 1 },
                                    { name: '2', id: 2 },
                                    { name: '3', id: 3 },
                                    { name: '4', id: 4 }
                                ]}
                                value={state.mADashboardDecimalPlaces}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={3}>
                    <InputLabel shrink required className="mandatoryfields" style={{ marginBottom: '-3px' }}>
                        Display Data?
                    </InputLabel>
                    <Grid container spacing={2}>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={state.displayDataLive} onChange={handleCheckbox} name="displayDataLive" />}
                                label="Live Data"
                            />
                        </Grid>
                        <Grid item style={{ marginLeft: '-10px' }}>
                            <FormControlLabel
                                control={<Checkbox checked={!state.displayDataLive} onChange={handleCheckbox} name="displayDataHistoric" />}
                                label="Historic Data"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left' }}>
                <Typography variant="h6" color="secondary">
                    Header/Footer
                </Typography>
                <hr />
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <Grid container>
                        <Grid item xs={12}>
                            <InputLabel shrink required className="mandatoryfields">
                                Use Header Colors?
                            </InputLabel>
                        </Grid>
                        <Grid item>
                            <RadioGroup
                                row
                                name="mADashboardUseHeaderColor"
                                value={state.mADashboardUseHeaderColor.toString()}
                                style={{ display: 'block' }}
                                onChange={(e) => {
                                    const useHeaderColors = e.target.value === 'true';
                                    setState((prev) => syncHeaderColors(prev, useHeaderColors));
                                }}
                            >
                                <FormControlLabel value="true" control={<Radio color="secondary" />} label="Yes" />
                                <FormControlLabel value="false" control={<Radio color="secondary" />} label="No" />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <Grid container direction="column">
                        <Grid item>
                            <InputLabel shrink required className="mandatoryfields" style={{ marginBottom: '8px' }}>
                                Colour
                            </InputLabel>
                        </Grid>
                        <Grid item>
                            <CustomColorPicker
                                width="100px"
                                height="25px"
                                name="mADashboardHeaderTextColor"
                                color={state.mADashboardHeaderTextColor}
                                onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardHeaderTextColor')}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <Grid container direction="column">
                        <Grid item>
                            <InputLabel shrink required className="mandatoryfields" style={{ marginBottom: '8px' }}>
                                Background
                            </InputLabel>
                        </Grid>
                        <Grid item>
                            <CustomColorPicker
                                width="100px"
                                height="25px"
                                name="mADashboardHeaderBgColor"
                                color={state.mADashboardHeaderBgColor}
                                onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardHeaderBgColor')}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={4}>
                    <InputLabel shrink>Footer Title</InputLabel>
                    <TextBox
                        placeholder="Footer Title"
                        value={state.mADashboardFooterTitle}
                        onChange={inputChange}
                        name="mADashboardFooterTitle"
                        error={!!state.errors.mADashboardFooterTitle}
                        inputProps={{ maxLength: 50 }}
                    />
                    <FormHelperText error>{state.errors.mADashboardFooterTitle}</FormHelperText>
                </Grid>
                <Grid item xs={1}>
                    <Grid container direction="column">
                        {' '}
                        <Grid item>
                            <InputLabel shrink style={{ marginBottom: '8px' }}>
                                Colour
                            </InputLabel>
                        </Grid>
                        <Grid item>
                            <CustomColorPicker
                                width="100px"
                                height="25px"
                                name="mADashboardFooterTextColor"
                                color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderTextColor : state.mADashboardFooterTextColor}
                                onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardFooterTextColor')}
                                disabled={state.mADashboardUseHeaderColor}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <Grid container direction="column">
                        {' '}
                        <Grid item>
                            <InputLabel shrink style={{ marginBottom: '8px' }}>
                                Background
                            </InputLabel>
                        </Grid>
                        <Grid item>
                            <CustomColorPicker
                                width="100px"
                                height="25px"
                                name="mADashboardFooterBgColor"
                                color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderBgColor : state.mADashboardFooterBgColor}
                                onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardFooterBgColor')}
                                disabled={state.mADashboardUseHeaderColor}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={2} style={{ marginTop: '20px' }}>
                    <FormControlLabel
                        control={<Checkbox checked={state.mADashboardShowTotalFooter} onChange={handleCheckbox} name="mADashboardShowTotalFooter" />}
                        label="Show Total Footer?"
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} style={{ top: 0, textAlign: 'left' }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <Typography variant="h6" color="secondary">
                            Category Columns
                        </Typography>
                    </Grid>
                    <Grid item xs>
                        <RadioGroup
                            style={{ display: 'block' }}
                            aria-label="mADashboardCategoryIsExpand"
                            name="mADashboardCategoryIsExpand"
                            value={state.mADashboardCategoryIsExpand.toString()}
                            onChange={handleInputChange}
                        >
                            <FormControlLabel value="true" control={<Radio />} label="Expanded" />
                            <FormControlLabel value="false" control={<Radio />} label="Collapsed" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <hr />
            </Grid>
            <Grid container>
                <Grid item xs={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                            <InputLabel shrink>Actual Column Name</InputLabel>
                            <TextBox
                                placeholder="Actual Name"
                                value={state.mADashboardActualName}
                                onChange={inputChange}
                                name="mADashboardActualName"
                                error={!!state.errors.mADashboardActualName}
                                inputProps={{ maxLength: 50 }}
                            />
                            <FormHelperText error>{state.errors.mADashboardActualName}</FormHelperText>
                        </Grid>
                        <Grid item xs={2}>
                            <Grid container direction="column">
                                {' '}
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Colour
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardActualTextColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderTextColor : state.mADashboardActualTextColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardActualTextColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={2}>
                            <Grid container direction="column">
                                {' '}
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Background
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardActualBgColor"
                                        id="mADashboardActualBgColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderBgColor : state.mADashboardActualBgColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardActualBgColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={4}>
                            <InputLabel shrink style={{ marginBottom: '-3px' }}>
                                Display
                            </InputLabel>
                            <Grid container>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={state.mADashboardActualHasTotal} onChange={handleCheckbox} name="mADashboardActualHasTotal" />
                                        }
                                        label="Total"
                                    />
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.mADashboardActualHasAverage}
                                                onChange={handleCheckbox}
                                                name="mADashboardActualHasAverage"
                                            />
                                        }
                                        label="Average"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                            <InputLabel shrink>Budget Column Name</InputLabel>
                            <TextBox
                                placeholder="Budget Name"
                                value={state.mADashboardBudgetName}
                                onChange={inputChange}
                                name="mADashboardBudgetName"
                                error={!!state.errors.mADashboardBudgetName}
                                inputProps={{ maxLength: 50 }}
                            />
                            <FormHelperText error>{state.errors.mADashboardBudgetName}</FormHelperText>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Colour
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardBudgetTextColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderTextColor : state.mADashboardBudgetTextColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardBudgetTextColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Background
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardBudgetBgColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderBgColor : state.mADashboardBudgetBgColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardBudgetBgColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <InputLabel shrink style={{ marginBottom: '-3px' }}>
                                Display
                            </InputLabel>
                            <Grid container>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={state.mADashboardBudgetHasTotal} onChange={handleCheckbox} name="mADashboardBudgetHasTotal" />
                                        }
                                        label="Total"
                                    />
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.mADashboardBudgetHasAverage}
                                                onChange={handleCheckbox}
                                                name="mADashboardBudgetHasAverage"
                                            />
                                        }
                                        label="Average"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                            <InputLabel shrink>Variance Column Name</InputLabel>
                            <TextBox
                                placeholder="Variance Name"
                                value={state.mADashboardVarianceName}
                                onChange={inputChange}
                                name="mADashboardVarianceName"
                                error={!!state.errors.mADashboardVarianceName}
                                inputProps={{ maxLength: 50 }}
                            />
                            <FormHelperText error>{state.errors.mADashboardVarianceName}</FormHelperText>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Colour
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardVarianceTextColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderTextColor : state.mADashboardVarianceTextColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardVarianceTextColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Background
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardVarianceBgColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderBgColor : state.mADashboardVarianceBgColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardVarianceBgColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <InputLabel shrink style={{ marginBottom: '-3px' }}>
                                Display
                            </InputLabel>
                            <Grid container>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.mADashboardVarianceHasTotal}
                                                onChange={handleCheckbox}
                                                name="mADashboardVarianceHasTotal"
                                            />
                                        }
                                        label="Total"
                                    />
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.mADashboardVarianceHasAverage}
                                                onChange={handleCheckbox}
                                                name="mADashboardVarianceHasAverage"
                                            />
                                        }
                                        label="Average"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                            <InputLabel shrink>KPIs Column Name</InputLabel>
                            <TextBox
                                placeholder="KPIs Name"
                                value={state.mADashboardKPIsName}
                                onChange={inputChange}
                                name="mADashboardKPIsName"
                                error={!!state.errors.mADashboardKPIsName}
                                inputProps={{ maxLength: 50 }}
                            />
                            <FormHelperText error>{state.errors.mADashboardKPIsName}</FormHelperText>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Colour
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardKPIsTextColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderTextColor : state.mADashboardKPIsTextColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardKPIsTextColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Background
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardKPIsBgColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderBgColor : state.mADashboardKPIsBgColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardKPIsBgColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <InputLabel shrink style={{ marginBottom: '-3px' }}>
                                Display
                            </InputLabel>
                            <Grid container>
                                <Grid item>
                                    <FormControlLabel
                                        control={<Checkbox checked={state.mADashboardKPIsHasTotal} onChange={handleCheckbox} name="mADashboardKPIsHasTotal" />}
                                        label="Total"
                                    />
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={state.mADashboardKPIsHasAverage} onChange={handleCheckbox} name="mADashboardKPIsHasAverage" />
                                        }
                                        label="Average"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                            <InputLabel shrink>Actual PY Name</InputLabel>
                            <TextBox
                                placeholder="Actual PY Name"
                                value={state.mADashboardActualPYName}
                                onChange={inputChange}
                                name="mADashboardActualPYName"
                                error={!!state.errors.mADashboardActualPYName}
                                inputProps={{ maxLength: 50 }}
                            />
                            <FormHelperText error>{state.errors.mADashboardActualPYName}</FormHelperText>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Colour
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardActualPYTextColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderTextColor : state.mADashboardActualPYTextColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardActualPYTextColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Background
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardActualPYBgColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderBgColor : state.mADashboardActualPYBgColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardActualPYBgColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <InputLabel shrink style={{ marginBottom: '-3px' }}>
                                Display
                            </InputLabel>
                            <Grid container>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.mADashboardActualPYHasTotal}
                                                onChange={handleCheckbox}
                                                name="mADashboardActualPYHasTotal"
                                            />
                                        }
                                        label="Total"
                                    />
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.mADashboardActualPYHasAverage}
                                                onChange={handleCheckbox}
                                                name="mADashboardActualPYHasAverage"
                                            />
                                        }
                                        label="Average"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container spacing={2} alignItems="center">
                        {/* Var PY Column Name Group */}
                        <Grid item xs={4}>
                            <InputLabel shrink>Var PY Name</InputLabel>
                            <TextBox
                                placeholder="Var PY Name"
                                value={state.mADashboardVarLYName}
                                onChange={inputChange}
                                name="mADashboardVarLYName"
                                error={!!state.errors.mADashboardVarLYName}
                                inputProps={{ maxLength: 50 }}
                            />
                            <FormHelperText error>{state.errors.mADashboardVarLYName}</FormHelperText>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Colour
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardVarLYTextColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderTextColor : state.mADashboardVarLYTextColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardVarLYTextColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container direction="column">
                                <Grid item>
                                    <InputLabel shrink style={{ marginBottom: '8px' }}>
                                        Background
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <CustomColorPicker
                                        width="100px"
                                        height="25px"
                                        name="mADashboardVarLYBgColor"
                                        color={state.mADashboardUseHeaderColor ? state.mADashboardHeaderBgColor : state.mADashboardVarLYBgColor}
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, 'mADashboardVarLYBgColor')}
                                        disabled={state.mADashboardUseHeaderColor}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <InputLabel shrink style={{ marginBottom: '-3px' }}>
                                Display
                            </InputLabel>
                            <Grid container>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={state.mADashboardVarLYHasTotal} onChange={handleCheckbox} name="mADashboardVarLYHasTotal" />
                                        }
                                        label="Total"
                                    />
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={state.mADashboardVarLYHasAverage} onChange={handleCheckbox} name="mADashboardVarLYHasAverage" />
                                        }
                                        label="Average"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} style={{ top: 0, textAlign: 'left' }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <Typography variant="h6" color="secondary">
                            Category Data
                        </Typography>
                    </Grid>
                    <Grid item xs>
                        <RadioGroup
                            style={{ display: 'block' }}
                            aria-label="mADashboardCategoryDataCalculated"
                            name="mADashboardCategoryDataCalculated"
                            value={String(state.mADashboardCategoryDataCalculated)}
                            onChange={handleInputChange}
                        >
                            <FormControlLabel value="0" control={<Radio />} label="Standard" />
                            <FormControlLabel value="1" control={<Radio />} label="Calculated from other categories" />
                            <FormControlLabel value="2" control={<Radio />} label="Calculated from Total" />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <hr />
            </Grid>
            {state.mADashboardCategoryDataCalculated ? (
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <InputLabel shrink required className="mandatoryfields">
                            Calculation
                        </InputLabel>
                        <TextBox
                            disabled={true}
                            placeholder="Calculation"
                            onChange={inputChange}
                            value={otherCategories.maMappingCategoryCalculationOtherCategoriesIDValue
                                .replace(/#(\d+)#/g, (_, id) => {
                                    const item = state.otherCategories.find((obj) => obj.id === parseInt(id));
                                    return item ? item.name.trim() : '';
                                })
                                // Add spaces around operators and parentheses
                                .replace(/([+\-*/()])/g, ' $1 ')
                                // Replace multiple spaces with a single space
                                .replace(/\s+/g, ' ')
                                // Trim leading/trailing space
                                .trim()}
                            name="maMappingCategoryCalculationOtherCategories"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CustomIconButton toolTipTitle="Reset" onClick={resetCalclations}>
                                            <RotateLeftIcon />
                                        </CustomIconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <InputLabel shrink required className="mandatoryfields">
                            Select Category
                        </InputLabel>
                        {/* <SelectBox onChange={inputChange} List={state.maMappingCategoryList} value={state.stdDataCategory} />  */}
                        <SingelSelect
                            onChange={handleOtherDataCategorySelect}
                            options={state.otherCategories || []}
                            value={otherCategories.selectedDataCategoryOtherCategories}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={1}>
                        <InputLabel shrink required className="mandatoryfields">
                            Symbol
                        </InputLabel>
                        <SingelSelect
                            onChange={handleSymbolSelect('selectedSymbolOtherCategories')}
                            options={state.symbols}
                            value={otherCategories.selectedSymbolOtherCategories}
                            getOptionLabel={(option) => option.label || ''}
                        />
                    </Grid>
                </Grid>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <InputLabel shrink required className="mandatoryfields">
                            Title
                        </InputLabel>
                        <TextBox
                            placeholder="Title"
                            value={state.maMappingCategoryTitle}
                            onChange={inputChange}
                            name="maMappingCategoryTitle"
                            error={!!state.errors.maMappingCategoryTitle}
                            inputProps={{ maxLength: 50 }}
                        />
                        <FormHelperText error>{state.errors.maMappingCategoryTitle}</FormHelperText>
                    </Grid>
                    {!state.maMappingCategoryCalculated && (
                        <Grid item xs={2} md={4} lg={5} xl={4}>
                            <InputLabel shrink required className="mandatoryfields">
                                Mapping Category
                            </InputLabel>
                            {/* <SelectBox onChange={inputChange} List={state.maMappingCategoryList} value={state.stdDataCategory} />  */}
                            <SingelSelect
                                onChange={handleMappingCatSelect('stdDataCategory')}
                                options={state.tempMAMappingCategoryList}
                                value={state.stdDataCategory}
                            />
                        </Grid>
                    )}
                    <Grid item xs={1} style={{ marginTop: 22 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={state.maMappingCategoryCalculated}
                                    onChange={(e) => {
                                        const isCalculated = e.target.checked;
                                        setState((prev) => ({
                                            ...prev,
                                            maMappingCategoryCalculated: isCalculated,
                                            MAMappingCategoryCalculation: isCalculated ? '' : prev.maMappingCategoryCalculation
                                        }));
                                    }}
                                    name="maMappingCategoryCalculated"
                                />
                            }
                            label="Calculation?"
                        />
                    </Grid>
                    {state.maMappingCategoryCalculated && (
                        <>
                            <Grid item xs={3}>
                                <InputLabel shrink required className="mandatoryfields">
                                    Calculation
                                </InputLabel>
                                <TextBox
                                    placeholder="Calculation"
                                    onChange={inputChange}
                                    value={state.maMappingCategoryCalculation}
                                    name="maMappingCategoryCalculation"
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <InputLabel shrink required className="mandatoryfields">
                                    Data Category
                                </InputLabel>
                                <SingelSelect
                                    onChange={handleDataCategorySelect}
                                    options={state.maMappingCategoryList.map((c) => ({
                                        value: c.id,
                                        name: c.name,
                                        code: c.code
                                    }))}
                                    value={state.selectedDataCategory}
                                />
                            </Grid>

                            <Grid item xs={1}>
                                <InputLabel shrink required className="mandatoryfields">
                                    Symbol
                                </InputLabel>
                                <SingelSelect
                                    onChange={handleSymbolSelect('selectedSymbol')}
                                    options={state.symbols}
                                    value={state.selectedSymbol}
                                    getOptionLabel={(option) => option.label || ''}
                                />
                            </Grid>
                        </>
                    )}
                    <Grid item xs={1}>
                        {state.isUpdate ? (
                            <SecondaryButton fullWidth onClick={addCategory} style={{ marginTop: 24 }}>
                                Update
                            </SecondaryButton>
                        ) : (
                            <SecondaryButton fullWidth onClick={addCategory} style={{ marginTop: 24 }}>
                                Add
                            </SecondaryButton>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer style={{ border: '1px solid rgba(0,0,0,0.2)', height: 'auto' }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <StyledTableRow>
                                        {/* <StyledTableCell width={'5%'}></StyledTableCell> */}
                                        <StyledTableCell width={'8%'}>Actions</StyledTableCell>
                                        <StyledTableCell>Type</StyledTableCell>
                                        <StyledTableCell>Category Title</StyledTableCell>
                                        <StyledTableCell>Category</StyledTableCell>
                                        <StyledTableCell>Calculation</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {state.maMappingCategoryID
                                        ?.filter((k) => !k.isDeleted)
                                        ?.map((row, i) => (
                                            <StyledTableRow key={row.maMappingCategoryTitle}>
                                                {/* <StyledTableCell>
                                            <EditIcon color="secondary" />
                                        </StyledTableCell> */}
                                                <StyledTableCell>
                                                    {editRowSelectedIndex === i ? (
                                                        <CheckCircleIcon
                                                            onClick={() => editRowSelect(null, null)}
                                                            fontSize="small"
                                                            style={{ cursor: 'pointer', color: 'green' }}
                                                        />
                                                    ) : (
                                                        <EditIcon
                                                            onClick={() => editRowSelect(row, i)}
                                                            fontSize="small"
                                                            style={{ cursor: 'pointer', color: '#2964D9' }}
                                                        />
                                                    )}
                                                    <DeleteOutlineIcon
                                                        onClick={() => handleDeleteRecord(row)}
                                                        color="secondary"
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                    {!row.isLocal && (
                                                        <>
                                                            {row.maMappingCategorySequence != state.smallSequence && (
                                                                <Tooltip title="Up Sequence" aria-label="add">
                                                                    <ArrowUpwardRounded
                                                                        fontSize="small"
                                                                        color="action"
                                                                        onClick={() => handleMoveClick(row, 'up')}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                            {row.maMappingCategorySequence != state.bigSequence && (
                                                                <Tooltip title="Down Sequence" aria-label="add">
                                                                    <ArrowDownwardRounded
                                                                        fontSize="small"
                                                                        color="action"
                                                                        onClick={() => handleMoveClick(row, 'down')}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                        </>
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell>{row.maMappingCategoryCalculated ? 'Calculated' : 'Standard'}</StyledTableCell>
                                                <StyledTableCell>{row.maMappingCategoryTitle}</StyledTableCell>
                                                <StyledTableCell>{row.category}</StyledTableCell>
                                                <StyledTableCell>{row.maMappingCategoryCalculation}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            )}

            <Grid item xs={12}>
                <SecondaryButton onClick={submitFrom} fullWidth disabled={loading} style={{ marginTop: '20px' }}>
                    {isAdd ? 'Add Category' : 'Update Category'}
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default DashboardAddUpdateModal;
